import {GroupsType} from "@/types/step.ts";

const groupsList = import.meta.glob(
    '@/components/templates/**/data/groups.ts',
    { eager: false }
) as Record<string, () => Promise<{ default: GroupsType[] }>>;

export async function getTemplateGroups(templateName: string):
    Promise<GroupsType[]> {
    const key = Object.keys(groupsList).find((path) =>
        path.includes(`/templates/${templateName}/data/groups.ts`)
    );

    if (!key) throw new Error(`Brak configu dla szablonu ${templateName}`)

    const groupsModule = await groupsList[key]();
    return groupsModule.default;
}